import { IApiTradingAccountCardInfo } from '@api/interfaces/data-contracts';
import { IApiTradingAccountCardInfoExt } from '@components-member/TradingAccounts/interfaces';
import { getAccountType } from '@components-member/psp/deposit/analyticsEvents/depositAnalyticsEvents';
import { IBasePluginProps, AccountInfo, IForm } from 'components/user/psp/psp.interfaces';
import { TRANSFER_ACCOUNT_TYPE } from 'global.enums';
import { IPlugin, IUser, IUserProfile } from 'global.interfaces';

export const getQuickDepositClickBtnEventData = (user: IUser, parentIbUserIdHash: string | null) => {
  const { idHash, profile } = user;
  const { clientSourceType, status } = profile;

  return {
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    verification: status,
  };
};

export const getAccountCardDepositClickEventData = (
  userInfo: IUser,
  userProfile: IUserProfile,
  account: IApiTradingAccountCardInfo,
  event: string,
) => {
  const { parentIbUserIdHash } = userProfile;
  const { profile, idHash } = userInfo;
  const { clientSourceType, status } = profile;

  return {
    event,
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    account,
    verification: status,
  };
};

type GetDepositPreStartEventDataProps = Pick<
  IBasePluginProps,
  'selectedPlugin' | 'selectedCategory' | 'accounts' | 'userInfo' | 'userProfile'
>;

export const getDepositPreStartEventData = (form: IForm, props: GetDepositPreStartEventDataProps) => {
  const { userInfo, selectedPlugin, selectedCategory, accounts, userProfile } = props;
  const { profile, idHash } = userInfo;
  const { parentIbUserIdHash } = userProfile;
  const { clientSourceType, status } = profile;

  const selectedAccount = accounts.find((account) => account.value === form.account) as AccountInfo;

  const accountType = getAccountType({
    accountType: selectedAccount.accountType as TRANSFER_ACCOUNT_TYPE,
    groupMappingType: selectedAccount.groupMappingType,
    investorId: selectedAccount.investorId,
    masterId: selectedAccount.masterId,
  });

  return {
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    accountIdHash: (selectedAccount as never as IApiTradingAccountCardInfoExt).idHash,
    accountType,
    account: selectedAccount,
    depositValue: form.amount,
    depositCurrency: form.currency,
    depositAmountUSD: form.amountUSD,
    depositSource: selectedPlugin.name,
    depositFundsType: selectedCategory,
    verification: status,
  };
};

export const getSelectDepositFundsCategoryEventData = (
  depositFundsType: string,
  userInfo: IUser,
  userProfile: IUserProfile,
) => {
  const { parentIbUserIdHash } = userProfile;
  const { profile, idHash } = userInfo;
  const { clientSourceType, status } = profile;

  return {
    depositFundsType,
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    verification: status,
  };
};

export const getDepositPaymentSourceEventData = (
  depositFundsType: string,
  depositSource: string,
  userInfo: IUser,
  userProfile: IUserProfile,
) => {
  const { parentIbUserIdHash } = userProfile;
  const { profile, idHash } = userInfo;
  const { clientSourceType, status } = profile;

  return {
    depositFundsType,
    depositSource,
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    verification: status,
  };
};

export const getAuthorizedBankingMethodEventData = (
  type: IPlugin,
  selectedCategory: string,
  userInfo: IUser,
  userProfile: IUserProfile,
) => {
  const { parentIbUserIdHash } = userProfile;
  const { profile, idHash } = userInfo;
  const { clientSourceType, status } = profile;

  return {
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    verification: status,
    eventAction: type.depositAdminAction,
    depositFundsType: selectedCategory,
  };
};

export const getsSuccessDepositEventData = (
  form: IForm,
  selectedAccountType: string,
  accountIdHash: string,
  selectedPlugin: IPlugin,
  selectedCategory: string,
  depositIdHash: string,
  userProfile: IUserProfile,
  userInfo: IUser,
) => {
  const { parentIbUserIdHash } = userProfile;
  const { profile, idHash } = userInfo;
  const { clientSourceType, status } = profile;

  return {
    accountIdHash,
    depositIdHash,
    depositValue: form.amount,
    depositAmountUSD: form.amountUSD,
    depositCurrency: form.currency,
    depositSource: selectedPlugin.name,
    userIdHash: idHash,
    clientSourceType,
    ibUserId: parentIbUserIdHash,
    accountType: selectedAccountType,
    depositFundsType: selectedCategory,
    verification: status,
  };
};
